<template>
  <div class="min-h-screen flex items-center justify-center bg-surface-50 dark:bg-surface-950 px-4 relative overflow-hidden">
    <!-- Background decoration -->
    <div class="absolute inset-0 bg-pattern-dots pointer-events-none opacity-40 dark:opacity-100"></div>
    <div class="absolute top-1/4 -left-32 w-96 h-96 bg-accent-500/10 dark:bg-accent-500/5 rounded-full blur-3xl pointer-events-none"></div>
    <div class="absolute bottom-1/4 -right-32 w-96 h-96 bg-primary-500/10 dark:bg-primary-500/5 rounded-full blur-3xl pointer-events-none"></div>

    <div class="text-center relative z-10 animate-fade-up">
      <!-- Error Image -->
      <div class="mb-10">
        <img
          src="../../assets/ErrorPageImage.png"
          alt="404 Error"
          class="mx-auto h-56 w-auto drop-shadow-2xl"
        />
      </div>

      <!-- Error Code -->
      <div class="mb-4">
        <span class="font-mono text-7xl sm:text-8xl font-bold gradient-accent-text tracking-tight">
          404
        </span>
      </div>

      <!-- Error Title -->
      <h2 class="text-display-sm text-surface-900 dark:text-surface-100 mb-4">
        Page Not Found
      </h2>

      <!-- Error Description -->
      <p class="text-lg text-surface-500 dark:text-surface-400 mb-10 max-w-md mx-auto leading-relaxed">
        Oops! The page you're looking for doesn't exist or has been moved.
      </p>

      <!-- Action Buttons -->
      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <BaseButton
          variant="accent"
          size="lg"
          @click="$router.go(-1)"
          :icon="ArrowLeftIcon"
        >
          Go Back
        </BaseButton>

        <BaseButton
          variant="secondary"
          size="lg"
          @click="$router.push('/dashboard')"
          :icon="HomeIcon"
        >
          Go to Dashboard
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@/components/ui/BaseButton.vue'
import { ArrowLeftIcon, HomeIcon } from '@heroicons/vue/24/outline'
</script>
